module.exports = __webpack_public_path__ + "img/Roberto-Ruiz-Yecora.0d7fa81a.png";